import React, { createContext, useContext } from 'react'

import { OrderAttempt } from 'utils/analytics/orderAttempt'
import { OrderLaunchedFrom } from 'models/purchaseFlow/orderLaunchedFrom'
import { isEmbedRoute } from 'constants/router'
import { useOrderAttempt } from 'utils/analytics/useOrderAttempt'

const PfOrderAttemptIdContext = createContext<OrderAttempt | undefined>(undefined)

/**
 * One attempt per PF v2 mount, the way legacy does: adopted from the click that started it, else minted with the
 * surface's fallback (Propstack opening the embed flow, or a direct entry). Its id is a Mixpanel super property for
 * the attempt's events; id and entry point go with the placement so the server-side purchase joins the attempt.
 */
export const PfOrderAttemptIdProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const attempt = useOrderAttempt(isEmbedRoute() ? 'crm_order_card' : 'direct')
  return <PfOrderAttemptIdContext.Provider value={attempt}>{children}</PfOrderAttemptIdContext.Provider>
}

/** The current flow's attempt id; `undefined` outside `PfOrderAttemptIdProvider`. */
export const usePfOrderAttemptId = (): string | undefined => useContext(PfOrderAttemptIdContext)?.orderAttemptId

/** Where the current flow was opened from; `undefined` outside `PfOrderAttemptIdProvider`. */
export const usePfOrderLaunchedFrom = (): OrderLaunchedFrom | undefined => useContext(PfOrderAttemptIdContext)?.launchedFrom
